import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { leagueMeta, leagueOrder, liveAndUpcoming, matches } from '@/lib/site';

export default function LiveSidebar() {
  const liveNow = matches.filter((item) => item.status === 'live');
  const queue = liveAndUpcoming(matches.filter((item) => item.status !== 'live')).slice(0, 4);

  return (
    <aside className="flex flex-col gap-4">
      <div className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
        <div className="flex items-center justify-between px-4 py-3 border-b border-background-200">
          <h3 className="font-heading text-sm tracking-wider text-foreground-900 flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse-dot" />
            正在直播
          </h3>
          <span className="text-xs text-foreground-500">{liveNow.length} 场进行中</span>
        </div>
        <div className="divide-y divide-background-200">
          {liveNow.length === 0 && (
            <p className="px-4 py-6 text-xs text-foreground-500">当前暂无正在直播的赛事</p>
          )}
          {liveNow.map((match) => (
            <Link
              key={match.id}
              to={`/detail/${match.id}`}
              className="block px-4 py-3 hover:bg-background-100 transition-colors"
            >
              <div className="flex items-center justify-between gap-2 mb-2">
                <span className="text-[11px] text-foreground-500">{match.leagueLabel}</span>
                <span className="inline-flex items-center gap-1 text-[11px] font-medium text-accent-600">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse-dot" />
                  {match.quarter}
                </span>
              </div>
              <div className="flex items-center justify-between gap-2">
                <div className="flex flex-col gap-1 min-w-0">
                  <span className="text-sm text-foreground-900 truncate">{match.home.name}</span>
                  <span className="text-sm text-foreground-900 truncate">{match.away.name}</span>
                </div>
                <div className="flex flex-col gap-1 items-end">
                  <span className="font-heading text-base text-accent-600 leading-none">{match.home.score}</span>
                  <span className="font-heading text-base text-accent-600 leading-none">{match.away.score}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <Link
          to="/category/nba"
          className="flex items-center justify-center gap-1.5 px-4 py-2.5 text-xs text-primary-700 bg-primary-50 hover:bg-primary-100 transition-colors"
        >
          查看全部赛事
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
        <div className="px-4 py-3 border-b border-background-200">
          <h3 className="font-heading text-sm tracking-wider text-foreground-900 flex items-center gap-2">
            <i className="ri-time-line text-secondary-500" />
            即将开赛
          </h3>
        </div>
        <ul className="divide-y divide-background-200">
          {queue.map((match, i) => (
            <Fragment key={match.id}>
              <li>
                <Link to={`/detail/${match.id}`} className="flex items-start gap-3 px-4 py-3 hover:bg-background-100 transition-colors">
                  <span className="font-heading text-lg text-background-300 w-6 leading-none mt-0.5">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="flex-1 min-w-0">
                    <span className="block text-sm text-foreground-900 truncate">
                      {match.home.shortName} vs {match.away.shortName}
                    </span>
                    <span className="block text-[11px] text-foreground-500 mt-1">
                      {match.leagueLabel} · {match.timeLabel}
                    </span>
                  </span>
                  <span className="text-[11px] text-accent-700 whitespace-nowrap mt-0.5">
                    {match.timeLabel}
                  </span>
                </Link>
              </li>
            </Fragment>
          ))}
        </ul>
      </div>

      <div className="rounded-lg bg-primary-900 px-4 py-5">
        <p className="font-heading text-[11px] tracking-[0.24em] text-accent-400 mb-2">LEAGUE INDEX</p>
        <h3 className="font-heading text-base text-background-50 mb-3">按联赛快速找比赛</h3>
        <div className="grid grid-cols-3 gap-2">
          {leagueOrder.map((key) => (
            <Link
              key={key}
              to={`/category/${key}`}
              className="flex flex-col items-center gap-1.5 rounded-md bg-background-50/10 py-3 text-[11px] text-background-100 hover:bg-accent-500 hover:text-background-50 transition-colors"
            >
              <i className={`${leagueMeta[key].icon} text-lg`} />
              {leagueMeta[key].name}
            </Link>
          ))}
        </div>
      </div>
    </aside>
  );
}